module.exports = __webpack_public_path__ + "static/recruit-banner-759114271eaf328e8a854c8f5ef0c33f.svg";